module.exports = __webpack_public_path__ + "img/slider.fdb8d39.jpg";